import React, { createContext, useContext, useState, setState, useEffect } from 'react';
import ThemeContext from '../contexts/ThemeContext';
import { useTheme } from '../theme/useTheme';
import { GlobalStyles } from "../theme/createGlobalStyles";
import { ThemeProvider as ThemeProviderSc } from 'styled-components';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';


const ThemeProvider = (props) => {
    const { theme, themeLoaded, getFonts } = useTheme();
    const [selectedTheme, setSelectedTheme] = useState(theme);
    useEffect(() => {
        setSelectedTheme(theme);
    }, [themeLoaded]);


    return (
        themeLoaded && (<ThemeContext.Provider value={{
            selectedTheme,
            setSelectedTheme
        }}>
            <ThemeProviderSc theme={selectedTheme}>
                <GlobalStyles />
                {props.children}
            </ThemeProviderSc>
        </ThemeContext.Provider>)
    )
};

export default ThemeProvider;
